module.exports = __webpack_public_path__ + "static/img/500000Pkg.fb5b5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/500000Pkg.png
// module id = X3PX
// module chunks = 0